import React from 'react'
import { CheckCircle2 } from 'lucide-react'
import Logo from '../../images/logo.svg?react'
import { useTranslation } from '@/hooks/useTranslation'

/**
 * Where Stripe sends a partner when they finish onboarding. Public, because the
 * partner has no Georgia account, and deliberately inert: it asks for nothing, shows
 * nothing about the organisation, and links nowhere.
 *
 * Whether the account can actually take charges is decided by Stripe and reaches
 * Georgia through `account.updated`, so this page does not claim it.
 */
const PartnerOnboardingComplete: React.FC = () => {
  const { t } = useTranslation()

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-gray-50 p-6 font-[Sora]">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-xl">
        <div className="mb-6 flex justify-center">
          <Logo height={40} fill="#0F4C3A" />
        </div>
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#E8F5EE] text-[#0F4C3A]">
          <CheckCircle2 className="h-6 w-6" />
        </div>
        <h1 className="text-xl font-bold text-[#0F4C3A]">{t('payments.onboardingComplete.title')}</h1>
        <p className="mt-3 text-sm text-[#4A5D52]">{t('payments.onboardingComplete.body')}</p>
        <p className="mt-2 text-sm text-[#6B7D72]">{t('payments.onboardingComplete.close')}</p>
      </div>
    </main>
  )
}

export default PartnerOnboardingComplete
